// extracted by mini-css-extract-plugin
export default {"app":"app_app__OsQoD","main":"app_main__Mk+bc"};